import { createRule } from "@regle/core"
import { useKnownBusinessEntityStore } from "@/store/known-business-entities.store.ts"
import { storeToRefs } from "pinia"
import { KnownBusinessEntity } from "@/models/known-business-entity.model.ts"

export const countryAndRegistrationNumberIsUniqueValidator = createRule({
  validator: (_value: unknown, model: KnownBusinessEntity) => {
    const knownBusinessEntityStore = useKnownBusinessEntityStore()
    const { knownBusinessEntities } = storeToRefs(knownBusinessEntityStore)
    return !knownBusinessEntities.value.some((knownBusinessEntity) => {
      return (
        knownBusinessEntity.registrationNumber &&
        knownBusinessEntity.countryOfRegistration &&
        knownBusinessEntity.registrationNumber === model.registrationNumber &&
        knownBusinessEntity.countryOfRegistration === model.countryOfRegistration &&
        knownBusinessEntity.id !== model.id
      )
    })
  },
  message: "Er bestaat al een bedrijf met deze combinatie van land en registratienummer"
})
